import Text from 'components/common/Text';

const MaxDiscountMessage = ({ maxDiscountMessage }) => {
  if (!maxDiscountMessage) return null;

  return (
    <div className="mb-2 flex">
      <Text brandStylesOverrides="textSm text-charcoal-90" htmlElement="span">
        {maxDiscountMessage}
      </Text>
    </div>
  );
};

MaxDiscountMessage.propTypes = {
  maxDiscountMessage: PropTypes.string,
};

export default MaxDiscountMessage;
